"use strict";

class CasseteSelect {
    constructor(selectBox = "CasseteSelectBox", initALL = true) {
        this.selectBox = selectBox;
        console.log(`Init Cassete type select interactive box module`);
        if (initALL) this.initDialog();
    }

    initDialog() {
        // init interactive act
        $('#' + this.selectBox)
            .on('shown.bs.modal', (event) => this.loadControlsValues(event))
            .on('hidden.bs.modal', () => this.finalizeBox())
            .on('keypress', (event) => {
                if (event.keyCode === 10 || event.keyCode === 13) {
                    this.onConfirm(event);
                    event.preventDefault();
                }
            })
            .find("button.confirm")
                .on('click', (event) => this.onConfirm(event));

        $("#" + this.selectBox + " .btn.box-cassete-control").hover(
            (event) => {
                $(event.currentTarget).find('img').prop('src', $(event.currentTarget).find('img').prop('src').replace(/.svg/g, "_blue.svg"));
            },
            (event) => {
                $(event.currentTarget).find('img').prop('src', $(event.currentTarget).find('img').prop('src').replace(/_blue.svg/g, ".svg"));
            });
        return this;
    }

    loadControlsValues() {
        let $cassetes_automation_controls = $("#cassetes .automation-control"),
            selectedCasseteValue = $cassetes_automation_controls.filter(".active").find("> input:radio").val();

        $("#" + this.selectBox + " input[name=cassette_box_scheme]").filter("[value=" + selectedCasseteValue + "]").parent().button("toggle");
    }

    onConfirm() {
        let selectedCasseteType = $("#" + this.selectBox).modal("hide").find(".box-cassete-control.active > input:radio").val();
        $("#cassetes .automation-control > input:radio").filter("[value=" + selectedCasseteType + "]").parent().button("toggle");
    }

    finalizeBox() {}
}

export default CasseteSelect;
